import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Auth } from './shared/services/auth.service';

export function useAppRouter() {
    const router = useRouter();

    const routeTransition = ref<'scale' | ''>('scale');
    router.beforeEach(async (to, from) => {
        if (from.path.substring(1).replace(/\/.*$/, '') === to.path.substring(1).replace(/\/.*$/, '')) {
            routeTransition.value = '';
        } else {
            routeTransition.value = 'scale';
        }
    });

    const isRouterReady = ref(false);
    router.isReady().then(() => {
        isRouterReady.value = true;
    });

    const routeExists = computed(() => router.currentRoute.value.matched.length > 0);
    const isPublicRoute = computed(() => router.currentRoute.value.meta.public);

    const routerViewKey = computed(() => {
        return Auth.tenantId.value ?? 'unauthed';
    });

    return { isPublicRoute, isRouterReady, routeExists, routeTransition, routerViewKey };
}
